import React, { useState, useEffect, useRef } from "react";
import { map } from "lodash";
import PropTypes from "prop-types";

// Redux
import { connect } from "react-redux";
import genericAction from "@Actions/generic";

// Components
import IkTable from "@Components/IkTable";
import Screen from "@Components/Screen";

// Utils
import dataHandler from "@Utils/dataHandler";

// Modals
import MtnUserCrud from "./Modals/MtnUserCrud";

// Styles
import styles from "./styles.module.css";

const UserPermissions = ({ dispatch, companyName, userName }) => {
	const [tableValue, setTableValue] = useState([]);
	const [openMtnUserCrud, setOpenMtnUserCrud] = useState(false);
	const [filteredItems, setFilteredItems] = useState([]);
	const [modalOption, setModalOption] = useState("");
	const [groupsData, setGroupsData] = useState("");
	const [perfilesList, setPerfilesList] = useState("");
	const [menuData, setMenuData] = useState("");
	const [filteredCount, setfilteredCount] = useState(null);
	const [filteredPrintData, setFilteredPrintData] = useState([]);
	const [groupTypes, setGroupTypes] = useState([]);
	const [currentParams, setCurrentParams] = useState({ page: 1, orderKey: "userId", orderDir: "desc", rows: 15, isActive: 1 });
	const [statusFilter, setStatusFilter] = useState("active");
	const statusFilterRef = useRef("active");
	const [newUsersFilter, setNewUsersFilter] = useState(false);
	const newUsersFilterRef = useRef(false);

	const defaultParams = { page: 1, orderKey: "userId", orderDir: "desc", rows: 15, isActive: 1 };

	useEffect(() => {
		(async () => {
			const usersPromise = dataHandler({ dispatch, url: "users", params: defaultParams });
			const groupsPromise = dispatch(genericAction({ method: "get", route: "groups/all" }));
			const menuPromise = dispatch(genericAction({ method: "get", route: "menu/all" }));
			const perfilesPromise = dispatch(genericAction({ method: "get", route: "profiles/all" }));
			const typesGroupPromise = dispatch(genericAction({ method: "get", route: "types/groups" }));

			const [usersResponse, groupsResponse, menuResponse, perfilesResponse, typesGroupResponse] = await Promise.all([
				usersPromise,
				groupsPromise,
				menuPromise,
				perfilesPromise,
				typesGroupPromise,
			]);

			setPerfilesList(perfilesResponse);
			setGroupsData(groupsResponse);
			setMenuData(menuResponse);
			setGroupTypes(typesGroupResponse);

			const mapusers = map(usersResponse.items, (user) => {
				const groupsModified = map(user.groups, (group) => {
					const type = typesGroupResponse.find((g) => {
						return g.id === group.typeId;
					});
					const typeName = type ? type.name : "Sin Tipo";
					return {
						...group,
						name: `${typeName} - ${group.name}`,
					};
				});
				return { ...user, ...user.user, groups: groupsModified };
			});

			setfilteredCount(usersResponse.count);
			setFilteredItems(mapusers);
			setCurrentParams(defaultParams);
		})();
	}, []);

	// modal handler
	const modalData = (name, item) => {
		setTableValue(item);
		setModalOption(name);
		setOpenMtnUserCrud(true);
	};

	// table Handler
	const handleButtom = (name, item) => {
		switch (name) {
			case "Watch":
			case "Edit":
				modalData(name, item);
				break;
			case "Add":
				modalData(name, []);
				break;
			default:
				break;
		}
	};

	// Table handlers
	const handlerData = async (params, printable) => {
		const finalParams = { ...params };

		if (newUsersFilterRef.current) {
			finalParams.isActive = 0;
			finalParams.page = 1;
			finalParams.rows = 9999;

			const data = await dataHandler({ dispatch, url: "users", params: finalParams });

			let mapusers = map(data.items, (user) => {
				const groupsModified = map(user.groups, (group) => {
					const type = groupTypes.find((g) => {
						return g.id === group.typeId;
					});
					const typeName = type ? type.name : "Sin Tipo";
					return {
						...group,
						name: `${typeName} - ${group.name}`,
					};
				});
				return { ...user, ...user.user, groups: groupsModified };
			});

			mapusers = mapusers.filter((user) => {
				const hasProfile = user.perfil && typeof user.perfil === "object" && Object.keys(user.perfil).length > 0;
				const hasRole = user.role && typeof user.role === "string" && user.role.trim() !== "";
				return !hasProfile && !hasRole;
			});

			if (printable) {
				setFilteredPrintData(mapusers);
			} else {
				const requestedPage = params.page || 1;
				const requestedRows = params.rows || 15;
				const startIndex = (requestedPage - 1) * requestedRows;
				const paginatedItems = mapusers.slice(startIndex, startIndex + requestedRows);

				setFilteredItems(paginatedItems);
				setfilteredCount(mapusers.length);
				setCurrentParams(params);
			}
			return;
		}

		if (statusFilterRef.current === "active") {
			finalParams.isActive = 1;
		} else if (statusFilterRef.current === "inactive") {
			finalParams.isActive = 0;
		} else {
			delete finalParams.isActive;
		}

		const data = await dataHandler({ dispatch, url: "users", params: finalParams });

		const mapusers = map(data.items, (user) => {
			const groupsModified = map(user.groups, (group) => {
				const type = groupTypes.find((g) => {
					return g.id === group.typeId;
				});
				const typeName = type ? type.name : "Sin Tipo";
				return {
					...group,
					name: `${typeName} - ${group.name}`,
				};
			});
			return { ...user, ...user.user, groups: groupsModified };
		});

		if (printable) {
			setFilteredPrintData(mapusers);
		} else {
			setFilteredItems(mapusers);
			setfilteredCount(data.count);
			setCurrentParams(params);
		}
	};

	const handleStatusChange = (e, { value }) => {
		setNewUsersFilter(false);
		newUsersFilterRef.current = false;
		setStatusFilter(value);
		statusFilterRef.current = value;
		const newParams = { ...currentParams, page: 1 };
		if (value === "all") {
			delete newParams.isActive;
		} else {
			newParams.isActive = value === "active" ? 1 : 0;
		}
		handlerData(newParams);
	};

	const handleNewUsersClick = () => {
		const newValue = !newUsersFilterRef.current;
		setNewUsersFilter(newValue);
		newUsersFilterRef.current = newValue;

		if (newValue) {
			setStatusFilter("all");
			statusFilterRef.current = "all";
			const newParams = { ...currentParams, page: 1 };
			delete newParams.isActive;
			handlerData(newParams);
		} else {
			setStatusFilter("active");
			statusFilterRef.current = "active";
			const newParams = { ...defaultParams };
			handlerData(newParams);
		}
	};

	const apiData = async () => {
		// if (name === "Edit") setOpenMtnUserCrud(false);

		const profilesResponse = await dataHandler({
			dispatch,
			url: "users",
			params: currentParams,
		});

		const mapusers = map(profilesResponse.items, (user) => {
			const groupsModified = map(user.groups, (group) => {
				const type = groupTypes.find((g) => {
					return g.id === group.typeId;
				});
				const typeName = type ? type.name : "Sin Tipo";
				return {
					...group,
					name: `${typeName} - ${group.name}`,
				};
			});
			return { ...user, ...user.user, groups: groupsModified };
		});

		setfilteredCount(profilesResponse.count);
		setFilteredItems(mapusers);
	};

	const setRowStyle = (item) => {
		if (!item.isActive) {
			return { backgroundColor: "rgba(255, 0, 0, 0.24)" };
		}
		return null;
	};

	return (
		<Screen hasHeader hasSidebar headerTitle="Usuarios">
			<div className={styles.container}>
				<div className={styles.containerTableGroup}>
					<div className={styles.tableGroupList}>
						<IkTable
							data={filteredItems}
							columns={[
								{
									label: "Acciones",
									action: [{ content: "edit", color: "#3f7ea3", onClick: "Edit", type: "icon" }],
									dataPosition: "center",
									width: 1,
									canFilter: false,
									canSort: false,
								},
								{
									label: "ID",
									key: "userId",
									format: "string",
									dataPosition: "center",
									width: 0.5,
									canFilter: true,
									canSort: true,
									canPrint: true,
									canExcel: true,
								},
								{
									label: "Activo",
									key: "isActive",
									format: "boolean",
									dataPosition: "center",
									headerPosition: "center",
									boolLabels: { true: "Si", false: "No" },
									width: 0.5,
									canFilter: true,
									canSort: true,
									canPrint: true,
									canExcel: true,
								},

								{
									label: "Usuario",
									key: "user.nickName",
									format: "string",
									width: 1,
									canFilter: true,
									canSort: true,
									canPrint: true,
									canExcel: true,
								},
								{
									label: "Nombre Completo",
									key: "user.fullName",
									format: "string",
									headerPosition: "left",
									width: 1,
									canFilter: true,
									canSort: true,
									canPrint: true,
									canExcel: true,
								},
								{
									label: "Perfil",
									key: "role",
									format: "string",
									width: 1,
									canFilter: true,
									canSort: true,
									canPrint: true,
									canExcel: true,
								},
								{
									label: "Correo",
									key: "user.email",
									format: "string",
									headerPosition: "left",
									dataPosition: "left",
									width: 1,
									canFilter: true,
									canSort: true,
									canPrint: true,
									canExcel: true,
								},
								{
									label: "Teléfono",
									key: "user.phone",
									format: "phone",
									dataPosition: "left",
									headerPosition: "left",
									width: 1,
									canFilter: true,
									canSort: true,
									canPrint: true,
									canExcel: true,
								},

								{
									label: "Grupos",
									format: "arrayTruncate",
									key: "groups,name",
									headerPosition: "left",
									width: 15,
								},
							]}
							totalRows={filteredCount}
							filteredPrintData={filteredPrintData}
							defaultParams={currentParams}
							mobileCardView
							cardLine1={[
								{ key: "userId", label: "ID" },
								{ key: "isActive", label: "" },
							]}
							cardLine2={[
								{ key: "user.fullName", label: "Nombre" },
								{ key: "user.nickName", label: "Usuario" },
							]}
							cardLine3={[
								{ key: "user.email", label: "Correo" },
								{ key: "user.phone", label: "Teléfono" },
							]}
							cardLine4={[
								// { key: "role", label: "Rol" },
								{ key: "groups,name", label: "Grupos" },
							]}
							dataHandler={handlerData}
							handlerTable={handleButtom}
							hidePrintButtons
							addButton={{ label: "Agregar" }}
							searcher={{ width: "40rem", hideOnMobile: true }}
							print={{ printHeader: { company: companyName, title: "Usuarios", user: userName } }}
							setRowStyle={setRowStyle}
							topButtons={[
								{
									componentType: "DropDown",
									value: statusFilter,
									options: [
										{ key: "all", value: "all", text: "Todos" },
										{ key: "active", value: "active", text: "Activos" },
										{ key: "inactive", value: "inactive", text: "Inactivos" },
									],
									onChange: handleStatusChange,
								},
								{
									componentType: "Button",
									content: " Nuevos",
									icon: "user plus",
									className: newUsersFilter ? styles.newUsersButtonActive : styles.newUsersButton,
									onClick: handleNewUsersClick,
								},
							]}
						/>
					</div>
				</div>
			</div>

			{openMtnUserCrud && (
				<MtnUserCrud
					tableValue={tableValue}
					groupsData={groupsData}
					perfilesList={perfilesList}
					menuData={menuData}
					apiData={apiData}
					onClose={() => {
						return setOpenMtnUserCrud(false);
					}}
					modalCrud={modalOption}
				/>
			)}
		</Screen>
	);
};

function mapStateToProps({ user, company }) {
	return {
		user,
		companyName: company.name,
		userName: user.name,
	};
}

UserPermissions.propTypes = {
	companyName: PropTypes.string,
	userName: PropTypes.string,
	dispatch: PropTypes.func,
};

export default connect(mapStateToProps)(UserPermissions);
